import { render, staticRenderFns } from "./WaitingforCommercializingPostDoc.vue?vue&type=template&id=700c7c85&"
import script from "./WaitingforCommercializingPostDoc.vue?vue&type=script&lang=js&"
export * from "./WaitingforCommercializingPostDoc.vue?vue&type=script&lang=js&"
import style0 from "./WaitingforCommercializingPostDoc.vue?vue&type=style&index=0&id=700c7c85&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports